import type {
  DependencyEntry,
  DependencyGroupType,
  DependencySortColumn,
  SortDirection,
} from "metabase-types/api";

const GRAPH_URL = `/data-studio/dependencies`;
const DIAGNOSTICS_URL = `/monitor/dependency-diagnostics`;

export type DependencyGraphParams = {
  entry?: DependencyEntry;
  baseUrl?: string;
};

export function dependencyGraph({
  entry,
  baseUrl = GRAPH_URL,
}: DependencyGraphParams = {}) {
  const searchParams = new URLSearchParams();
  if (entry != null) {
    searchParams.set("id", String(entry.id));
    searchParams.set("type", entry.type);
  }
  const queryString = searchParams.toString();
  return queryString.length > 0 ? `${baseUrl}?${queryString}` : baseUrl;
}

export function dependencyDiagnostics() {
  return DIAGNOSTICS_URL;
}

export type DependencyDiagnosticsParams = {
  page?: number;
  query?: string;
  groupTypes?: DependencyGroupType[];
  includePersonalCollections?: boolean;
  sortColumn?: DependencySortColumn;
  sortDirection?: SortDirection;
};

function dependencyDiagnosticsQueryString({
  page,
  query,
  groupTypes,
  includePersonalCollections,
  sortColumn,
  sortDirection,
}: DependencyDiagnosticsParams = {}) {
  const searchParams = new URLSearchParams();

  if (page != null) {
    searchParams.set("page", String(page));
  }
  if (query != null) {
    searchParams.set("query", query);
  }
  if (groupTypes != null) {
    groupTypes.forEach((groupType) => {
      searchParams.append("group-types", groupType);
    });
  }
  if (includePersonalCollections != null) {
    searchParams.set(
      "include-personal-collections",
      String(includePersonalCollections),
    );
  }
  if (sortColumn != null) {
    searchParams.set("sort-column", sortColumn);
  }
  if (sortDirection != null) {
    searchParams.set("sort-direction", sortDirection);
  }

  const queryString = searchParams.toString();
  return queryString.length > 0 ? `?${queryString}` : "";
}

export function brokenDependencies(params?: DependencyDiagnosticsParams) {
  return `${dependencyDiagnostics()}/broken${dependencyDiagnosticsQueryString(params)}`;
}

export function unreferencedDependencies(params?: DependencyDiagnosticsParams) {
  return `${dependencyDiagnostics()}/unreferenced${dependencyDiagnosticsQueryString(params)}`;
}
